import React from "react";

// Модальное окно для отображения homework
export default function HomeworkModal({ selectedHomework, handleCloseHomework, handleCheckHomework }) {
  if (!selectedHomework) return null;

  return (
    <div className="homework-modal-overlay" onClick={handleCloseHomework}>
      <div className="homework-modal" onClick={(e) => e.stopPropagation()}>
        <div className="homework-modal-header">
          <h2>{selectedHomework.title || 'Untitled Homework'}</h2>
          <button className="close-modal-btn" onClick={handleCloseHomework}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="homework-modal-content">
          <div className="homework-modal-info">
            <div className="info-row">
              <span className="info-label">Due Date:</span>
              <span className="info-value">
                {selectedHomework.dueDate ? new Date(selectedHomework.dueDate).toLocaleDateString() : 'No due date'}
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">Status:</span>
              <span className={`status-badge ${selectedHomework.status || 'draft'}`}>
                {(selectedHomework.status || 'draft').charAt(0).toUpperCase() + (selectedHomework.status || 'draft').slice(1)}
              </span>
            </div>
            {selectedHomework.grade && (
              <div className="info-row">
                <span className="info-label">Grade:</span>
                <span className="grade-badge">{selectedHomework.grade}%</span>
              </div>
            )}
          </div>

          {selectedHomework.description && (
            <div className="homework-description">
              <h3>Description</h3>
              <p>{selectedHomework.description}</p>
            </div>
          )}

          {selectedHomework.containerContents && selectedHomework.containerContents.length > 0 && (
            <div className="homework-content">
              <h3>Content</h3>
              {selectedHomework.containerContents.map((container, index) => (
                <div key={container.id} className="content-container">
                  <div className="content-header">
                    <span className="container-number">Section {index + 1}</span>
                  </div>
                  <div
                    className="content-body"
                    dangerouslySetInnerHTML={{ __html: container.content }}
                  />
                </div>
              ))}
            </div>
          )}

          {selectedHomework.tasks && selectedHomework.tasks.length > 0 && (
            <div className="homework-tasks">
              <h3>Tasks</h3>
              <div className="tasks-list">
                {selectedHomework.tasks.map((task, index) => (
                  <div key={task.id || index} className={`task-item ${task.completed ? 'completed' : ''}`}>
                    <span className="task-checkbox">
                      {task.completed ? '✓' : '○'}
                    </span>
                    <span className="task-text">{task.text}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="homework-modal-actions">
          {(selectedHomework.status || 'draft') === 'assigned' && (
            <button className="modal-action-btn submit-btn" onClick={() => handleCheckHomework(selectedHomework.id)}>
              Check Homework
            </button>
          )}
          {(selectedHomework.status || 'draft') === 'submitted' && (
            <button className="modal-action-btn review-btn">
              Review & Grade
            </button>
          )}
          {(selectedHomework.status || 'draft') === 'reviewed' && (
            <button className="modal-action-btn view-btn" onClick={() => { handleCheckHomework(selectedHomework.id); handleCloseHomework(); }}>
              View Feedback
            </button>
          )}
          <button className="modal-action-btn close-btn" onClick={handleCloseHomework}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
